export default "__VITE_ASSET__BbFHO93D__"